import {Component} from '@angular/core';
import {MatSnackBar, MatSnackBarDismiss, MatSnackBarRef, TextOnlySnackBar} from '@angular/material/snack-bar';
import {firstValueFrom, interval, of} from 'rxjs';
import {filter, first, switchMap} from 'rxjs/operators';

import {InfoApiService, UserService} from '@atmi/core';
import {RequestService} from '@atmi/core/services/request.service';
import {SettingsApiService} from '@atmi/core/services/settings-api.service';
import {UndoService} from '@atmi/core/services/undo.service';

export const isMatSnackBarDismiss = (value: any): value is MatSnackBarDismiss => value?.MatSnackBarDismiss ?? false;

@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
})
export class AppComponent {

  private snackBarRef: MatSnackBarRef<TextOnlySnackBar> | null = null;

  constructor(
    private readonly snackBarService: MatSnackBar,
    private readonly undoService: UndoService,
    private readonly requestService: RequestService,
    private readonly userService: UserService,
    private readonly infoApi: InfoApiService,
    private readonly settingsApi: SettingsApiService,
  ) {

    /*@TODO sottoscrivere errori e non mostrare operazione conclusa con successo in tal caso*/
    console.log('app component constructor');
    this.requestService.requestStateStream$
      .pipe(
        switchMap((state) => {
          if (!state && this.snackBarRef) {
            this.snackBarRef.dismiss();
            this.snackBarService.open('Operazione conclusa con successo', 'Ok', {duration: 3000});
            this.snackBarRef = null;
          } else if (state?.request) {
            this.snackBarRef = this.snackBarService.open('Operazione richiesta in corso');
          } else if (state?.error) {
            const errorMessage =
              state.error?.error?.error?.description ||
              state.error?.error?.message ||
              state.error?.message ||
              '';
            this.snackBarRef = this.snackBarService.open(`Operazione non riuscita! ${errorMessage}`, 'Chiudi',);
          }

          return this.snackBarRef?.afterDismissed() || of(false);
        }),
      )
      .subscribe((action: MatSnackBarDismiss | boolean) => {

        if (isMatSnackBarDismiss(action) && action.dismissedByAction) {
          this.undoService.setIsUndo(true);
        }
        this.snackBarRef = null;
      });

    /*@TODO manage in different way*/
    interval(300000)
      .pipe(
        switchMap(() => this.userService.selectAuthenticatedState()),
        filter((authenticate) => !!authenticate),
        switchMap(() => this.infoApi.info()),
      )
      .subscribe();

    // System settings are now initialized only after a successful login.
    // The login flow (UserService + SessionsController) will:
    // - authenticate the user
    // - store token and user id
    // - then any feature modules can trigger settings loads as needed.
  }

  async initSystemSettings() {
    // Kept for backward compatibility; no-op until authenticated.
    await firstValueFrom(
      this.userService
        .selectAuthenticatedState()
        .pipe(first((authenticated) => !!authenticated)),
    );
    await firstValueFrom(this.settingsApi.systemSettings().pipe(first()));
  }
}

/*
* [
    "@angular/animations",
    "@angular/cdk",
    "@angular/common",
    "@angular/compiler",
    "@angular/core",
    "@angular/forms",
    "@angular/material",
    "@angular/platform-browser",
    "@angular/platform-browser-dynamic",
    "@angular/router",
    "@ng-select/ng-select",
    "@ngx-translate/core",
    "@ngx-translate/http-loader",
    "@swimlane/ngx-datatable",
    "fast-deep-equal",
    "file-saver",
    "ngx-mask",
    "ngx-spinner",
    "rxjs",
    "sweetalert2",
    "ts-md5",
    "tslib",
    "zone.js",
    "@ngneat/elf-cli",
]*/
